import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const getDailyRequestRange = ({ startTimestamp, endTimestamp }, zone) => ({
    // Daily posts use UTC midnight, while the date selector follows the viewer's day.
    startTimestamp: dayjs
        .utc(dayjs(startTimestamp).tz(zone).format('YYYY-MM-DD'))
        .toISOString(),
    endTimestamp: dayjs
        .utc(dayjs(endTimestamp).tz(zone).format('YYYY-MM-DD'))
        .toISOString()
});
